import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "create__signatories" }
const _hoisted_2 = { class: "white__navbar" }
const _hoisted_3 = { key: 2 }
const _hoisted_4 = { class: "create__signatories__content" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "content" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StepOne = _resolveComponent("StepOne")!
  const _component_StepTwo = _resolveComponent("StepTwo")!
  const _component_pagination = _resolveComponent("pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.document.signatory_parent != 0 && _ctx.document.signatory_parent_type=='proxy')
        ? (_openBlock(), _createElementBlock("p", {
            key: 0,
            style: {"cursor":"pointer"},
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.open_doc && _ctx.open_doc(...args)))
          }, " Доверенность №" + _toDisplayString(_ctx.document.signatory_parent), 1))
        : _createCommentVNode("", true),
      (_ctx.document.signatory_parent != 0 && _ctx.document.signatory_parent_type=='document')
        ? (_openBlock(), _createElementBlock("p", {
            key: 1,
            style: {"cursor":"pointer"},
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.open_doc && _ctx.open_doc(...args)))
          }, " Заявление №" + _toDisplayString(_ctx.document.signatory_parent), 1))
        : _createCommentVNode("", true),
      (_ctx.document.signatory_parent != 0)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, "/"))
        : _createCommentVNode("", true),
      _createElementVNode("p", null, "Подписант " + _toDisplayString(_ctx.document.signatory_lastname+' '+_ctx.document.signatory_firstname+' '+_ctx.document.signatory_patronymic), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      (_ctx.page === 1)
        ? (_openBlock(), _createBlock(_component_StepOne, {
            key: 0,
            document: _ctx.document,
            onGoDoc: _ctx.open_doc
          }, null, 8, ["document", "onGoDoc"]))
        : _createCommentVNode("", true),
      (_ctx.page === 2)
        ? (_openBlock(), _createBlock(_component_StepTwo, {
            key: 1,
            document: _ctx.document,
            onSave: _ctx.signatory_save,
            onEditSignatory: _ctx.edit_signatory,
            onEditProxy: _ctx.edit_proxy
          }, null, 8, ["document", "onSave", "onEditSignatory", "onEditProxy"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_pagination, {
      modelValue: _ctx.page,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.page) = $event)),
      style: _normalizeStyle('left: '+_ctx.pagination_bottom_left+' transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);'),
      page_arr: [
          {name: '1', title: 'ФИО доверителя', complete: ['signatory_lastname','signatory_firstname']},
          {name: '2', title: 'Паспортные данные', complete: ['signatory_passport_seria','signatory_passport_number','signatory_when_issued','signatory_passport_issued','signatory_division_code','signatory_passport_registration']},
        ],
      nav_btn: true,
      page: _ctx.page,
      document: _ctx.document,
      onChangePage: _ctx.change_page
    }, null, 8, ["modelValue", "style", "page", "document", "onChangePage"])
  ]))
}